import { PieChart } from "react-minimal-pie-chart";
import { Charity } from "../../../../../models/Charity";
import { generateColor } from "../../../../../utils/Utils";

export interface CharityPieProps {
  charities: Charity[];
}

export default function CharityPie(props: CharityPieProps) {
  const data =
    props.charities.length > 0
      ? Array.from({ length: props.charities.length }, (_, i) => {
          return {
            title: (props.charities[i].name ?? "Unknown") + "  |  " + props.charities[i].donationsReceived.pretty + " USDC",
            value: Number(props.charities[i].donationsReceived.value ?? 0n) + 1,
            color: generateColor(i / props.charities.length),
          };
        })
      : [
          {
            title: "No Charities yet.",
            value: 1,
            color: "#E0E0E0",
          },
        ];
  return (
    <div className="lg:w-56 w-40 lg:h-56 h-40 hover:scale-110 duration-250">
      <PieChart data={data} />
    </div>
  );
}
